import { render, staticRenderFns } from "./POSTopSection.vue?vue&type=template&id=071a2bb4&scoped=true&"
import script from "./POSTopSection.vue?vue&type=script&lang=js&"
export * from "./POSTopSection.vue?vue&type=script&lang=js&"
import style0 from "./POSTopSection.vue?vue&type=style&index=0&id=071a2bb4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071a2bb4",
  null
  
)

export default component.exports